<template>
  <div>
    <apexcharts v-if="!loading" :options="issuesOptions" :series="issuesCount"></apexcharts>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ProductInsights',
  components: {
    apexcharts: VueApexCharts
  },
  props: ['brandId', 'activitiesWithIssuesSummaryData'],
  data: function () {
    return {
      issuesCount: [],
      loading: true,
      issuesOptions: {
        chart: {
          title: {
            text: 'Activities with Issues summary'
          },
          type: 'pie'
        },
        labels: []
      }
    }
  },
  watch: {
    activitiesWithIssuesSummaryData () {
      this.issuesOptions.labels = []
      this.issuesCount = []

      this.activitiesWithIssuesSummaryData.forEach((q) => {
        this.issuesOptions.labels.push(q.issue)
        this.issuesCount.push(q.issue_count)
      })

      this.loading = false
    }
  }
}
</script>
